import { render, staticRenderFns } from "./ProjectPlanningConfig.vue?vue&type=template&id=2350c8e5&scoped=true&"
import script from "./ProjectPlanningConfig.vue?vue&type=script&lang=js&"
export * from "./ProjectPlanningConfig.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlanningConfig.vue?vue&type=style&index=0&id=2350c8e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2350c8e5",
  null
  
)

export default component.exports